import {
  GraduationCap,
  BookOpen,
  Flame,
  CalendarCheck,
  Dumbbell,
  UtensilsCrossed,
  Sparkles,
  NotebookPen,
  Users,
  MessagesSquare,
} from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";

const FEATURES = [
  {
    icon: GraduationCap,
    title: "Oltre 30 ore di formazione",
    desc: "Percorsi dedicati a identità maschile e femminile cristiana, Donna Virtuosa, Corpo come Tempio, Chiamati — scopo e direzione, disciplina, crescita personale e spirituale.",
  },
  {
    icon: BookOpen,
    title: "Approfondimenti biblici",
    desc: "Contenuti per conoscere meglio la Bibbia, iniziare a leggerla e approfondire la Parola.",
  },
  {
    icon: Flame,
    title: "Deserto — 40 giorni",
    desc: "Una sfida dedicata alla disciplina, alla riflessione e alla trasformazione delle abitudini.",
  },
  {
    icon: CalendarCheck,
    title: "Routine quotidiane",
    desc: "Strumenti per organizzare le giornate e sviluppare costanza e autocontrollo.",
  },
  {
    icon: Dumbbell,
    title: "Allenamenti",
    desc: "Allenamenti da svolgere a casa, in palestra oppure all'aperto.",
  },
  {
    icon: UtensilsCrossed,
    title: "Ricette e alimentazione",
    desc: "Idee e contenuti pratici per prendersi cura del corpo.",
  },
  {
    icon: Sparkles,
    title: "Versetti e riflessioni",
    desc: "Contenuti spirituali per accompagnarti durante la quotidianità.",
  },
  {
    icon: NotebookPen,
    title: "Diario personale",
    desc: "Uno spazio per annotare pensieri, riflessioni, obiettivi e progressi.",
  },
  {
    icon: Users,
    title: "Social community interno — incluso",
    desc: "Pubblica post, condividi fotografie, racconta la tua quotidianità, condividi riflessioni e testimonianze, interagisci e commenta con gli altri membri.",
  },
  {
    icon: MessagesSquare,
    title: "Chat e gruppi tematici — inclusi",
    desc: "Accesso alle chat interne e ai gruppi dedicati a uomini, donne, single e coppie.",
  },
];

export const AppPlanSection = () => (
  <section id="app" className="bg-[#121212] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Tempio Vivo App — 9,99 €/mese"
        title="Cresci ogni giorno. In autonomia, ma non in isolamento."
        subtitle="L'App Tempio Vivo è un ecosistema digitale di formazione, crescita e relazioni cristiane. Non è soltanto una libreria di videocorsi: è uno spazio in cui formarti, sviluppare nuove abitudini, prenderti cura del corpo e interagire con altri cristiani."
        testid="app-plan-heading"
      />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map((f, i) => (
          <Reveal key={f.title} delay={0.05 * (i % 3)}>
            <div
              data-testid={`app-feature-${i + 1}`}
              className="h-full rounded-sm border border-[#1B1B1B] bg-[#080808] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#C9A45C]/40"
            >
              <f.icon
                className="h-6 w-6 text-[#C9A45C]"
                aria-hidden="true"
                strokeWidth={1.5}
              />
              <h3 className="mt-4 text-base font-bold text-white">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#B8B8B8]">
                {f.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14 text-center">
        <p className="font-display text-2xl font-semibold uppercase text-white sm:text-3xl">
          Formazione. Disciplina. Fede. Relazioni.
          <br />
          <span className="text-[#C9A45C]">Tutto in un'unica app.</span>
        </p>
        <p
          data-testid="app-plan-price"
          className="font-display mt-8 text-5xl font-semibold text-white"
        >
          9,99&nbsp;€
          <span className="ml-2 align-middle text-base uppercase tracking-widest text-[#B8B8B8]">
            /mese
          </span>
        </p>
        <div className="mt-8">
          <CtaButton
            plan="app"
            testid="app-plan-cta-button"
            showArrow
            className="w-full sm:w-auto"
          >
            Inizia con Tempio Vivo App
          </CtaButton>
        </div>
        <p className="mt-4 text-xs uppercase tracking-widest text-[#8F7138]">
          Pagamento sicuro tramite Stripe. Attivazione assistita dal team.
        </p>
      </Reveal>
    </div>
  </section>
);
